import React from 'react';
import { 
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Divider,
  IconButton
} from '@mui/material';
import { Phone, Delete } from '@mui/icons-material';
import './CitaCard.css';

const CitaCard = ({ cita, onDoubleClick, onDelete }) => {
    console.log("CITA EN CitaCard:", cita);  // 👈 AQUÍ
  if (!cita) return null;

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete(cita.id_cita);
  };

  const tratamientos = cita.tratamientos || (cita.tratamiento ? [{ nombre: cita.tratamiento }] : []);
  const primerTratamiento = tratamientos[0];
  const tratamientosAdicionales = tratamientos.length - 1;
  // 👇 AQUÍ VA EL COLOR
const color = cita.tiene_ticket
  ? 'verde'
  : (cita.id_empleado === 4 ? 'azul' : 'naranja');  

  return (
    <div className="cita-card-container" onDoubleClick={onDoubleClick}>
  <Card className={`cita-card ${color}`}>
        <CardContent className="card-content">
          <Box className="cita-header">
            <Box className="client-info">
              <Typography className="client-name">
                {cita.nombre_cliente} {cita.apellidos_cliente}
              </Typography>
              {cita.telefono && (
                <Typography className="client-phone">
                  <Phone className="phone-icon" /> {cita.telefono}
                </Typography>
              )}
            </Box>
            <IconButton 
              onClick={handleDeleteClick}
              className="delete-button"
            >
              <Delete className="delete-icon" />
            </IconButton>
          </Box>

          <Divider className="divider" />

          <Box className="treatments-container">
            {primerTratamiento && (
              <Box className="treatment-item">
                <Typography className="treatment-name">
                  {primerTratamiento.nombre}
                </Typography>
                {tratamientosAdicionales > 0 && (
                  <Chip 
                    label={`+${tratamientosAdicionales}`}
                    className="treatment-count"
                  />
                )}
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default CitaCard;